// extracted by mini-css-extract-plugin
export default {"arrowBack":"xTGsSFGP1aTtZUqP60h5y"};